export const DEPARTMENT_LIST_REQUEST = "DEPARTMENT_LIST_REQUEST";
export const DEPARTMENT_LIST_SUCCESS = "DEPARTMENT_LIST_SUCCESS";
export const DEPARTMENT_LIST_FAIL = "DEPARTMENT_LIST_FAIL";

export const CATEGORY_LIST_REQUEST = "CATEGORY_LIST_REQUEST";
export const CATEGORY_LIST_SUCCESS = "CATEGORY_LIST_SUCCESS";
export const CATEGORY_LIST_FAIL = "CATEGORY_LIST_FAIL";

export const CATEGORY_SEARCH_REQUEST = "CATEGORY_SEARCH_REQUEST";
export const CATEGORY_SEARCH_SUCCESS = "CATEGORY_SEARCH_SUCCESS";
export const CATEGORY_SEARCH_FAIL = "CATEGORY_SEARCH_FAIL";
export const CATEGORY_SEARCH_RESET = "CATEGORY_SEARCH_RESET";

export const CATEGORY_SINGLE_REQUEST = "CATEGORY_SINGLE_REQUEST";
export const CATEGORY_SINGLE_SUCCESS = "CATEGORY_SINGLE_SUCCESS";
export const CATEGORY_SINGLE_FAIL = "CATEGORY_SINGLE_FAIL";
export const CATEGORY_SINGLE_RESET = "CATEGORY_SINGLE_RESET";

export const ADD_CATEGORY_REQUEST = "ADD_CATEGORY_REQUEST";
export const ADD_CATEGORY_SUCCESS = "ADD_CATEGORY_SUCCESS";
export const ADD_CATEGORY_FAIL = "ADD_CATEGORY_FAIL";

export const DELETE_CATEGORY_REQUEST = "DELETE_CATEGORY_REQUEST";
export const DELETE_CATEGORY_SUCCESS = "DELETE_CATEGORY_SUCCESS";
export const DELETE_CATEGORY_FAIL = "DELETE_CATEGORY_FAIL";

export const UPDATE_CATEGORY_REQUEST = "UPDATE_CATEGORY_REQUEST";
export const UPDATE_CATEGORY_SUCCESS = "UPDATE_CATEGORY_SUCCESS";
export const UPDATE_CATEGORY_FAIL = "UPDATE_CATEGORY_FAIL";
